var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isI18n
    ? _c(
        "b-modal",
        {
          attrs: {
            id: "operation-deactivate-modal-confirm",
            "data-cy": "operation-modal-confirm",
            "destroy-on-hide": true,
            "aria-role": "dialog",
            "aria-label": "Activar/Desactivar Operación",
            "has-modal-card": "",
            "trap-focus": "",
            "on-cancel": _vm.close,
            "aria-modal": "",
            width: "400",
          },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-card", staticStyle: { width: "auto" } },
            [
              _c("header", { staticClass: "modal-card-body" }, [
                _c("div", { staticClass: "modal-card-title modal-title" }, [
                  _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
                ]),
                _c("a", {
                  staticClass: "close-modal delete",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                }),
              ]),
              _c("section", { staticClass: "modal-card-body" }, [
                _c("p", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.operation.isActive
                          ? _vm.$t("subtitleDeactivate")
                          : _vm.$t("subtitleActivate")
                      ) +
                      " "
                  ),
                ]),
                _c("p", [
                  _c("strong", [
                    _vm._v(" " + _vm._s(_vm.$t("operation")) + " "),
                  ]),
                  _vm._v(" " + _vm._s(_vm.operation.companyOperationId)),
                  _c("br"),
                  _c("strong", [_vm._v(" " + _vm._s(_vm.$t("type")) + " ")]),
                  _vm._v(_vm._s(_vm.getOperationTypeTitle()) + " "),
                  _c("br"),
                  _c("strong", [
                    _vm._v(" " + _vm._s(_vm.$t("clientIdNumber")) + " "),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.operation.client
                          ? _vm.operation.client["idNumber"]
                          : ""
                      )
                  ),
                  _c("br"),
                ]),
                _c("p", { staticClass: "text-align-center" }, [
                  _vm._v(" " + _vm._s(_vm.$t("confirm")) + " "),
                ]),
                _c(
                  "div",
                  { staticClass: "text-align-center reasons-form" },
                  [
                    _c(
                      "b-field",
                      { attrs: { "custom-class": "has-text-weight-small" } },
                      [
                        _c(
                          "b-select",
                          {
                            attrs: {
                              id: "reason",
                              size: "is-small",
                              rounded: "",
                              name: "reason",
                            },
                            model: {
                              value: _vm.reason,
                              callback: function ($$v) {
                                _vm.reason = $$v
                              },
                              expression: "reason",
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.$t("pickReason"))),
                            ]),
                            _vm._l(
                              _vm.operation.isActive
                                ? _vm.$t("reasonsForDisable")
                                : _vm.$t("reasonsForEnable"),
                              function (key) {
                                return _c(
                                  "option",
                                  { key: key, domProps: { value: key } },
                                  [_vm._v(" " + _vm._s(key) + " ")]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      [
                        (_vm.stateUser && _vm.operation.isActive) ||
                        (!_vm.stateUser && !_vm.operation.isActive)
                          ? _c(
                              "b-checkbox",
                              {
                                staticClass: "checkbox",
                                attrs: { id: "deactivateUser" },
                                model: {
                                  value: _vm.disable,
                                  callback: function ($$v) {
                                    _vm.disable = $$v
                                  },
                                  expression: "disable",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.operation.isActive
                                        ? _vm.$t("deactivateUser")
                                        : _vm.$t("activateUser")
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "buttons is-pulled-right" },
                  [
                    _c("b-button", {
                      staticClass: "button is-button-secondary",
                      attrs: {
                        id: "operation-modal-button-no",
                        "data-cy": "operation-modal-button-no",
                        label: "No",
                        rounded: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    }),
                    _c("b-button", {
                      staticClass: "button is-button-primary",
                      attrs: {
                        id: "operation-modal-button-continuar",
                        "data-cy": "operation-modal-button-continuar",
                        label: "Continuar",
                        rounded: "",
                        disabled: !_vm.reason,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.confirm()
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }